import { render, staticRenderFns } from "./OnboardingUserAndCompany.vue?vue&type=template&id=d7edbc92&scoped=true&"
import script from "./OnboardingUserAndCompany.vue?vue&type=script&lang=js&"
export * from "./OnboardingUserAndCompany.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingUserAndCompany.vue?vue&type=style&index=0&id=d7edbc92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7edbc92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VTextField})
